import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import util from "./utils/utils"
import validate from './utils/validate'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import moment from 'moment'
import * as echarts from "echarts";
import 'core-js/stable'
import 'regenerator-runtime/runtime'

Vue.config.productionTip = false
Vue.prototype.$util = util
Vue.use(ElementUI);
Vue.use(validate)
Vue.prototype.$moment = moment
Vue.prototype.$EventBus = new Vue()
Vue.prototype.$echarts = echarts;

let flag = true;

router.beforeEach(async (to, from, next) => {
    if (to.meta.title) {
        document.title = '91家纺网商家管理中心 - ' + to.meta.title
    }

    if(to.meta.link){
        localStorage.removeItem('UserInfo');
        localStorage.removeItem('Router');
        window.location.href = util.getHost() + '?to='+to.meta.link;
        return
    }

    if (to.meta.requireAuth) {
        if(util.loginStatus() == false){
            flag=false
            next({
                path: '/login'
            })
        }else{
            next();
        }
    }


    if(to.path==='/login'){
        if(util.loginStatus()==true){
            next({
                path: '/'
            })
        }else{
            flag=false
        }
    }
    
    if(to.meta.link){
        window.location.href = util.getHost() + (to.meta.link == 'index' ? '' : to.meta.link)
    }

    if(flag){
        let routes = await util.routes();
        let routers = [];

        for(var i = 0; i < routes.length; i++){
            var child = routes[i].child;

            if(child){
                for(var j = 0; j < child.length; j++){
                    var meta = {
                        title: child[j].name,
                        requireAuth: true,
                        parent: child[j].parent
                    }

                    if(child[j].redirect != ''){
                        meta.link = child[j].redirect;
                    }

                    routers.push({
                        path: child[j].route,
                        component: child[j].component,
                        meta: meta,
                        hidden:child[j].is_menu===0?true:false
                    });
                }
            }
        }

        var children = router.options.routes[0].children;

        routers.forEach(item => {
            item.component = util.routerRequire(item.component);
            children.push(item);
        });

        router.options.routes[0].children = children;
        router.addRoute(router.options.routes[0]);
        router.addRoute({
            path: '*',
            redirect: '/404'
        });

        flag = false;

        next({
            ...to,
            replace: true
        })
    }else{
        next()
    }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')